import React, { useEffect, useState } from 'react';
import CardVal from 'card-validator';

import { CardImage } from './styles';

import amex from '../../../../images/amex.png';
import elo from '../../../../images/elo.png';
import master from '../../../../images/mastercard.png';
import visa from '../../../../images/visa.png';
import diners from '../../../../images/diners.png';
import { resolveCardBrand } from '../../utils/resolverCardBrand';

const renderIcon = (brand) => {
  switch (brand) {
    case 'american-express':
      return amex;
    case 'elo':
      return elo;
    case 'mastercard':
      return master;
    case 'visa':
      return visa;
    case 'diners-club':
      return diners;
    default:
      return null;
  }
};

export function CarBrand({ cardNumber, defaultBrand }) {
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    if (cardNumber) {
      if (defaultBrand) {
        setBrand(resolveCardBrand(defaultBrand));
      } else {
        const { card } = CardVal.number(cardNumber);

        setBrand(card?.type);
      }
    } else {
      setBrand(null);
    }
  }, [cardNumber, defaultBrand]);

  const brandSource = renderIcon(brand);

  return brandSource ? <CardImage src={brandSource} /> : null;
}

export default CarBrand;
